/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificationAlarmsSettings { 
    /**
     * Email address from which notifications must be sent.
     */
    from?: string | null;
    /**
     * Email address at which notifications must be sent.
     */
    to?: string | null;
    /**
     * Subject of notification message.
     */
    dailySubject?: string;
    /**
     * Indicates whether summary daily notifications is enabled.
     */
    readonly isDailyNotificationEnabled?: boolean;
    /**
     * Time of the day when summary daily notifications are sent.
     */
    dailyTime?: string;
    /**
     * Array of statuses that alarms must have to be included into daily notifications.
     */
    dailyStatusFilter?: Array<NotificationAlarmsSettingsDailyStatusFilter> | null;
    /**
     * Type of sorting applied to the list of alarms included into daily notifications.
     */
    dailySorting?: NotificationAlarmsSettingsDailySorting;
}
export enum NotificationAlarmsSettingsDailyStatusFilter {
    Unknown = 'Unknown',
    Resolved = 'Resolved',
    Info = 'Info',
    Warning = 'Warning',
    Error = 'Error',
    Acknowledged = 'Acknowledged'
};
export enum NotificationAlarmsSettingsDailySorting {
    Unknown = 'Unknown',
    ByTime = 'ByTime',
    ByStatus = 'ByStatus',
    ByObjectName = 'ByObjectName',
    ByAlarmName = 'ByAlarmName'
};



